function n(t) {
  return t;
}
export {
  n as identity
};
//# sourceMappingURL=index.js.map
